import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GlobalListTranslationDataService } from '../../services/global-list-translation-data.service';
import { GlobalListTranslation } from '../../models/global-list-translation-data.models';
import { environment } from '../../../environments/environment';
import { createStructSDK } from '@structdk/extension-sdk';

@Component({
  selector: 'app-global-list-translation',
  imports: [FormsModule, CommonModule],
  templateUrl: './global-list-translation.component.html',
  styleUrl: './global-list-translation.component.css',
})
export class GlobalListTranslationComponent implements OnInit {
  private pimUrl = environment.pimUrl;

  constructor(private globalListTranslationDataService: GlobalListTranslationDataService, private cdr: ChangeDetectorRef) {   
  }

  data: GlobalListTranslation[] = [];
  working: boolean = false;

  ngOnInit(): void {
    let qp = new URLSearchParams(window.location.search);

    this.loadGlobalListTranslationData();
  }

  loadGlobalListTranslationData(): void {
    this.working = true;
    this.globalListTranslationDataService.getData().subscribe({
      next: (response) => {
        this.data = response;
   
        this.working = false;

        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Lookup failed', error);
        this.cdr.detectChanges();
        this.working = false;
      }
    });
  }

  goToPimUrl(url: string): void {
    const struct = createStructSDK();

    struct.actions.navigate({ path: url });
  }
}
